import PropTypes from 'prop-types';
import React from 'react';

import { FooterContainer } from '@product-site-frontend/gatsby-theme-blocks';
import { Layout } from '@product-site-frontend/landing';

LandingLayout.propTypes = {
  children: PropTypes.node,
};

export default function LandingLayout({ children }) {
  return (
    <Layout>
      {children}
      <FooterContainer />
    </Layout>
  );
}
